import {
  App, reactive,
} from 'vue';
import {
  EventMessage,
  EventMessageUtils,
  EventType,
  InteractionStatus,
  PublicClientApplication,
  AccountInfo,
} from '@azure/msal-browser';
import { isAuthError } from '../util/isAuthError';
import { buildLoginRequest } from '../requests';

// TODO: check if this needs to change
type AccountIdentifiers = Partial<Pick<AccountInfo, 'homeAccountId'|'localAccountId'|'username'>>;

const FORGOTTEN_PASSWORD = 'AADB2C90118';
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */
const accountArraysAreEqual = (
  arrayA: Array<AccountIdentifiers>,
  arrayB: Array<AccountIdentifiers>,
): boolean => {
  if (arrayA.length !== arrayB.length) {
    return false;
  }

  const comparisonArray = [...arrayB];

  return arrayA.every((elementA) => {
    const elementB = comparisonArray.shift();
    if (!elementA || !elementB) {
      return false;
    }

    return (elementA.homeAccountId === elementB.homeAccountId)
               && (elementA.localAccountId === elementB.localAccountId)
               && (elementA.username === elementB.username);
  });
};

const handleLoginError = ({
  msalInstance,
  message,
  scopes,
}:
{
  msalInstance: PublicClientApplication,
  message: EventMessage,
  scopes: string[]}) => {
  const config = msalInstance.getConfiguration();

  if (!isAuthError(message.error)) {
    console.log(`b2c: login error has occurred: ${message.eventType} ${JSON.stringify(message.error)}`);
    return;
  }

  if (message.error.errorCode === FORGOTTEN_PASSWORD) {
    console.log('b2c: start forgotten password journey');
    try {
      const loginRequest = buildLoginRequest(config.auth.redirectUri, scopes);
      msalInstance.loginRedirect(loginRequest);
    } catch (err) {
      console.log(
        `b2c: init: password reset: error: ${JSON.stringify(err)}`,
      );
      return;
    }
    return;
  }
  console.log('b2c: login error has occurred:', message.eventType, message.error);
};

export const msalPlugin = {
  install: (app: App, msalInstance: PublicClientApplication, scopes: string[]) => {
    const inProgress: InteractionStatus = InteractionStatus.Startup;
    const accounts = msalInstance.getAllAccounts();

    console.log('ACtive account: ', msalInstance.getActiveAccount());

    const state = reactive({
      instance: msalInstance,
      inProgress: inProgress as InteractionStatus,
      accounts,
      activeAccount: msalInstance.getActiveAccount(),
    });

    // eslint-disable-next-line
    app.config.globalProperties.$msal = state;

    msalInstance.addEventCallback((message: EventMessage) => {
      const currentAccounts = msalInstance.getAllAccounts();
      state.activeAccount = msalInstance.getActiveAccount();
      if (!accountArraysAreEqual(currentAccounts, state.accounts)) {
        state.accounts = currentAccounts;
      }

      const status = EventMessageUtils.getInteractionStatusFromEvent(message, state.inProgress);
      if (status !== null) {
        state.inProgress = status;
      }

      if (message.eventType === EventType.LOGIN_FAILURE
      || message.eventType === EventType.SSO_SILENT_FAILURE) {
        handleLoginError({ msalInstance, message, scopes });
      }
      if (message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
        console.log('b2c: Error during token retrieval:', message.error);
      }
    });
  },
};
